/**
 * Minimal, pure WGS84 → EPSG:3857 (Web Mercator) conversion.
 * Used so the exportImage bbox we request from the ArcGIS ImageServer is
 * computed from the exact same lon/lat corners used for the Leaflet
 * ImageOverlay bounds — guaranteeing the returned PNG lines up with the map
 * pixel-for-pixel (Leaflet's default CRS is EPSG:3857).
 */

const EARTH_RADIUS_M = 6378137; // WGS84 semi-major axis, standard Web Mercator sphere radius

export interface MercatorPoint {
  x: number;
  y: number;
}

export function lonLatToMercator(lon: number, lat: number): MercatorPoint {
  const x = (lon * Math.PI * EARTH_RADIUS_M) / 180;
  const y =
    EARTH_RADIUS_M * Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360));
  return { x, y };
}

export interface LonLatBounds {
  west: number;
  south: number;
  east: number;
  north: number;
}

export interface MercatorBbox {
  xmin: number;
  ymin: number;
  xmax: number;
  ymax: number;
}

export function boundsToMercatorBbox(bounds: LonLatBounds): MercatorBbox {
  const sw = lonLatToMercator(bounds.west, bounds.south);
  const ne = lonLatToMercator(bounds.east, bounds.north);
  return { xmin: sw.x, ymin: sw.y, xmax: ne.x, ymax: ne.y };
}
